export const EWarehousesAction = {
  SET_WAREHOUSES: 'SET_WAREHOUSES',
  SET_SELECTED_WAREHOUSE: 'SET_SELECTED_WAREHOUSE',
  SET_PAGINATION: 'SET_PAGINATION_USERS',
  SET_SEARCH_PARAMS: 'SET_SEARCH_PARAMS',
};
